<script>
    // Stores 
    import { textSite, mailRH } from '../store.js'; 

    // Componentes
    import { Router, Link, link , Route } from "svelte-routing";
    import PageHeader from "../components/PageHeader.svelte";
    import Forms from "../components/Forms.svelte";

    // Code
    let titlePage = 'Trabalhe Conosco ';    

    let fields = [
        {
            title:  'Nome *',
            name:   'nome',
            required: 'required',
        },
        {
            title:  'Telefone *',
            name:   'telefone',
            required: 'required',
            classe: 'mask-telefone'
        },
        {
            title:  'Email *',
            name:   'email',
            type: 'email',
            required: 'required',
        },    
        {
            title:  'Endereço *',
            name:   'endereco',
            required: 'required',
        },         
        {
            title:  'Cidade *',
            name:   'cidade',
            required: 'required',
        },         
        {
            title:  'CEP',
            name:   'cep',
            classe: 'mask-cep'
        },         
        {
            title:  'Área de Interesse',
            name:   'area-interesse',
        },         
        {
            title:  'Experiências Profissionais',
            name:   'experiencias-profissionais',
        },         
        {
            title:  'Última Empresa',
            name:   'ultima-empresa',
        },         
        {
            title:  'Últimas Atividades',
            name:   'ultimas-atividades',
        },         
    ];      
    
    const message = `
Nome: {nome}
Telefone: {telefone}
Email: {email}
Endereço: {endereco}
Cidade: {cidade}
CEP: {cep}
Área de Interesse: {area-interesse}
Experiências Profissionais: {experiencias-profissionais}
Última Empresa: {ultima-empresa}
Últimas Atividades: {ultimas-atividades}

{info}
    `;

    let loading = false;
    function send() {
        loading = true;
    }    

</script>

<section class="conteudo-internas">
    <PageHeader title={titlePage}></PageHeader>

    <div class="container">
        <div class="text-center">
            <p>
                Utilize o formulário abaixo e envie seu currículo para o nosso Banco de Oportunidades.
            </p>
        </div>
        <div class="offset-md-3 col-md-6 pl-0 pr-0">    
            <hr class="line-separator">
            <Forms fields={fields} destiny={$mailRH} subjectTitle="Trabalhe Conosco | {$textSite}" {message} htmlbody={false} />
        </div>
    </div>
</section>